import React from 'react';
import PropTypes from 'prop-types';
import Row from '../../components/Row';
import Card from '../../components/Card';
import CardHeader from '../../components/card-header/CardHeader';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../components/HeaderSearchRefreshFilterOptions';
import CardBody from '../../components/CardBody';
import Paginator from '../../components/Paginator';
import { CurrentUser } from '../../model/CurrentUser';
import { connect } from 'react-redux';
import { PsDocument } from './PsDocument';
import { DocumentsTable } from './DocumentsTable';
import { bindActionCreators } from 'redux';
import * as attachmentActions from '../../../attachment/attachmentActions';
import { ButtonLabel } from '../../components/ButtonLabel';
import { PsChecks } from '../../model/PsChecks';
import { DocumentSearchTask } from './document-search/DocumentSearchTask';
import { DocumentSearchRequest } from './document-search/DocumentSearchRequest';
import DocumentState from '../../model/DocumentState';

const OptionsMore = {
    NONE: '',
    ATTACH: 'ATTACH',
};

export class Documents extends React.Component {

    checks = new PsChecks();

    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            data: [],
            error: '',
            search: props.initialCardState.search,
            filter: props.initialCardState.filter,
            loading: false,
            filters: [],
            collapsed: props.initialCardState.collapsed,
            checkedItems: [],
            moreOptionSelected: OptionsMore.NONE,
            pagination: {
                current: 0,
                total_pages: 0,
                total_elements: 0,
            },
        };
    }

    componentDidMount() {
        if ( !this.state.collapsed ) {
            this.listDocuments();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { states, dashboardState, saveCardState } = this.props;
        const { search, filter, collapsed } = this.state;

        if ( prevProps.states !== states ) {
            this.setState({ filters: this.parseToFilterOptions(states) });
        }

        if ( prevProps.dashboardState !== dashboardState ) {
            this.setState({ filter: dashboardState, page: 1 }, this.listDocuments);
        }

        if ((prevState.collapsed !== collapsed) && !collapsed) {
            this.listDocuments();
        }

        if ( prevState.filter !== filter ) {
            saveCardState({ filter });
        }

        if ( prevState.search !== search ) {
            saveCardState({ search });
        }

        if ( prevState.collapsed !== collapsed ) {
            saveCardState({ collapsed });
        }
    }

    render() {
        const {
            title,
            companyId,
            companyManagement,
        } = this.props;

        const {
            data,
            error,
            search,
            loading,
            collapsed,
            pagination,
            moreOptionSelected,
        } = this.state;

        const areChecksDisplayed = moreOptionSelected === OptionsMore.ATTACH;
        const hideOutsourceColumn = !!companyId;

        return (
            <Row>
                <Card loading={!collapsed && loading}>
                    <CardHeader
                        title={title.toUpperCase()}
                        subtitle={this.subtitle()}
                        rightOptions={(
                            <HeaderSearchRefreshFilterOptions
                                enableFilter={true}
                                filterOptions={this.filterOptions()}
                                searchText={search}
                                collapsed={collapsed}
                                onRefresh={this.listDocuments}
                                onSearch={this.search}
                                onCollapsed={this.collapse}
                                moreOptions={this.moreOptions()}
                            />
                        )}
                    />
                    {
                        !collapsed ? (
                            <CardBody>
                                <DocumentsTable
                                    data={data}
                                    error={error}
                                    loading={loading}
                                    checkItem={this.checkItem}
                                    isChecked={this.isChecked}
                                    checkPage={this.checkPage}
                                    uncheckPage={this.uncheckPage}
                                    isPageChecked={this.isPageChecked()}
                                    companyManagement={companyManagement}
                                    areChecksDisplayed={areChecksDisplayed}
                                    hideOutsourceColumn={hideOutsourceColumn}
                                />
                                <Paginator
                                    data={pagination}
                                    onPage={this.selectPage}
                                />
                                {
                                    areChecksDisplayed ? (
                                        <Row>
                                            <ButtonLabel
                                                label={I18nUtils.tr('TR_CANCELAR')}
                                                className={'col-md-3 col-md-offset-6'}
                                                onClick={this.cancelAttach}
                                            />
                                            <ButtonLabel
                                                label={I18nUtils.tr('TR_SUBIR')}
                                                className={'col-md-3'}
                                                disabled={this.checks.noneSelected()}
                                                onClick={this.acceptAttach}
                                            />
                                        </Row>
                                    ) : null
                                }
                            </CardBody>
                        ) : null
                    }
                </Card>
            </Row>
        );
    }

    search = (search) => {
        this.setState({ search, page: 1 }, this.listDocuments);
    };

    selectPage = (page) => {
        this.setState({ page }, this.listDocuments);
    };

    collapse = () => {
        this.setState((prevState) => ( { collapsed: !prevState.collapsed } ));
    };

    listDocuments = () => {
        const { schemaType, companyManagement, companyId, checkMonthly } = this.props;
        const { page, search, filter } = this.state;
        const request = new DocumentSearchRequest(
            schemaType,
            companyManagement,
            companyId,
            checkMonthly,
        );

        request.setPage(page);
        request.setTerm(search);
        request.setDocumentState(filter);

        new DocumentSearchTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                this.setState({
                    data: PsDocument.fromAPIDocuments(res.data),
                    pagination: res.pagination,
                    checkedItems: this.checks.reset(),
                });
            })
            .onFail(error => this.setState({ error }))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };

    parseToFilterOptions = (states) => {
        const options = [{
            id: DocumentState.ALL,
            title: I18nUtils.tr('TR_TODOS'),
            onClick: () => this.setState({ filter: DocumentState.ALL, page: 1 }, this.listDocuments),
        }];

        states.forEach((state) => {
            options.push({
                id: state.id,
                title: state.name,
                onClick: () => this.setState({ filter: state.id, page: 1 }, this.listDocuments),
            });
        });

        return options;
    };

    filterOptions = () => {
        return this.state.filters.map((filter) => ( {
            ...filter,
            active: filter.id === this.state.filter,
        } ));
    };

    moreOptions() {
        const { currentUser } = this.props;
        const { moreOptionSelected } = this.state;

        if ( currentUser.isSuperAdmin() || currentUser.isOutsourcesViewer() ) return [];

        return [
            {
                id: 'attach',
                title: I18nUtils.tr('TR_SUBIDA_MULTIPLE_DE_FICHEROS'),
                active: moreOptionSelected === OptionsMore.ATTACH,
                onClick: () => this.setState({ moreOptionSelected: OptionsMore.ATTACH }),
            },
        ];
    }

    subtitle = () => {
        const currentFilter = this.state.filters.find((f) => f.id === this.state.filter);
        return currentFilter ? currentFilter.title : '';
    };

    checkItem = (item) => {
        const itemId = item.id();
        const checkedItems = this.checks.check(itemId);
        this.setState({ checkedItems });
    };

    isChecked = (item) => {
        const itemId = item.id();
        return this.checks.isChecked(itemId);
    };

    checkPage = () => {
        const pageIds = this.state.data.map(item => item.id());
        const checkedItems = this.checks.checkPage(pageIds);
        this.setState({ checkedItems });
    };

    uncheckPage = () => {
        const checkedItems = this.checks.reset();
        this.setState({ checkedItems });
    };

    isPageChecked = () => {
        const pageIds = this.state.data.map(item => item.id());
        return this.checks.isPageChecked(pageIds);
    };

    cancelAttach = () => {
        const checkedItems = this.checks.reset();
        this.setState({ checkedItems, moreOptionSelected: OptionsMore.NONE });
    };

    acceptAttach = () => {
        if ( this.checks.hasSelected() ) {
            const { data, checkedItems } = this.state;
            const currentPathname = window.document.location.pathname;
            const apiDocuments = data
                .filter((doc) => checkedItems.includes(doc.id()))
                .map((doc) => doc.apiDocument());

            this.props.attachmentActions.addAlldocsToAttach(apiDocuments);
            this.props.attachmentActions.goToRouteAttachment(currentPathname);
        }
    };
}

const mapStateToProps = (state) => ( { currentUser: CurrentUser.fromReduxState(state) } );

const mapDispatchToProps = dispatch => ( {
    attachmentActions: bindActionCreators(attachmentActions, dispatch),
} );

export const DocumentsCard = connect(mapStateToProps, mapDispatchToProps)(Documents);

DocumentsCard.propTypes = {
    title: PropTypes.string.isRequired,
    states: PropTypes.array.isRequired,
    companyId: PropTypes.number,
    schemaType: PropTypes.number.isRequired,
    dashboardState: PropTypes.number,
    companyManagement: PropTypes.string.isRequired,
    saveCardState: PropTypes.func,
    initialCardState: PropTypes.object.isRequired,
    checkMonthly: PropTypes.bool,
};

DocumentsCard.defaultProps = {
    saveCardState: () => null,
    initialCardState: {
        search: '',
        filter: DocumentState.ALL,
        collapsed: false,
        checkMonthly: false,
    },
};



// WEBPACK FOOTER //
// ./src/app/shared/document/list/DocumentsCard.jsx